/** isTwilioConversationsEnabled toggles for use case where EU deployment has Twilio Conversations turned off */
export const isTwilioConversationsEnabled = (): boolean => {
  return (window as any)?.figureheadConfig?.REACT_APP_TWILIO_CONVERSATIONS_ENABLED
}
